import * as React from "react";
const SvgFiRrUniformMartialArts = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-uniform-martial-arts_svg__a)">
      <path
        fill="#062147"
        d="M19.576.691C18.38.232 17.177 0 16 0H8C6.823 0 5.62.232 4.423.691 1.777 1.709 0 4.326 0 7.204V19c0 1.103.897 2 2 2h2.142c.447 1.721 1.999 3 3.858 3h8c1.859 0 3.411-1.279 3.858-3H22c1.103 0 2-.897 2-2V7.204c0-2.878-1.777-5.495-4.424-6.513m-7.551 5.337L9.723 2h4.568zM2 7.204c0-2.056 1.263-3.923 3.141-4.646a8.2 8.2 0 0 1 2.292-.536l3.45 6.037L6.979 15h-.978V7a1 1 0 1 0-2 0v12H2zM16 22H8c-1.103 0-2-.897-2-2v-3h3.975C9.464 17.835 9 18.889 9 20a1 1 0 1 0 2 0c0-.83.51-1.753 1-2.436.49.683 1 1.607 1 2.436a1 1 0 1 0 2 0c0-1.111-.464-2.165-.975-3H18v3c0 1.103-.897 2-2 2m6-3h-2V7a1 1 0 1 0-2 0v8H9.272l7.299-12.977c.751.061 1.519.24 2.287.535C20.737 3.281 22 5.148 22 7.204z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-uniform-martial-arts_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUniformMartialArts;
